import React from 'react';
import useScript from 'react-script-hook/lib/use-script';
//style
import styles from 'src/asset/scss/style/user.mypage.module.scss'
//hooks
import useAuthHook from 'src/webapp/hooks/auth/auth.hook';
//comp-wrapper
import Section from 'src/webapp/views/wrapper/Section';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import TitleBar from 'src/webapp/views/component/title/TitleBar';//타이틀
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Profile from './comp/profile/Profile';//프로필정보 & 수정
import BizTimeList from './comp/bizDate/BizTimeList';//영업시간정보&수정
import VehicleList from './comp/VehicleList';//취급차량목록
import NoticeList from './comp/NoticeList';//공지사항목록
import Button from './comp/Button';//버튼목록
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function Mypage() {
    useScript({ src: 'https://t1.kakaocdn.net/kakao_js_sdk/2.4.0/kakao.min.js', onload: () => console.log('Script loaded!') });
    const { onLogoutHandler } = useAuthHook();//로그아웃
    
    /* =============== 카카오톡채널연결 =============== */
    const kakaoChannel = async() => {
        if(window.Kakao) {
            const kakao = window.Kakao;
            const KAKAO_SCRIPT_INIT = `${process.env.REACT_APP_KAKAO_LOGIN_CLIENT_ID}`;
            const KAKAO_CHANNEL_ID = `${process.env.REACT_APP_KAKAO_CHANNEL_ID}`;
    
            if (!kakao.isInitialized()) { kakao.init(KAKAO_SCRIPT_INIT); }
            kakao.Channel.chat({ channelPublicId: KAKAO_CHANNEL_ID });
        }
    }
    /* =============== 카카오톡채널연결 =============== */

    return (
        <Section className={"section sectionContainer"}>
            <Menu />
            <Element tag={`div`} className={`container`}>
                <FixedPanel>
                    <TitleBar title={`마이페이지`} />
                </FixedPanel>
                <FlickPanel>
                    <Element tag={`div`} className={styles.btnContainer}>
                        <Element tag={`button`} anyprop={(e) => kakaoChannel()}>고객센터</Element>
                        <Element tag={`button`} anyprop={(e) => onLogoutHandler()}>로그아웃</Element>
                    </Element>
                    <Profile />
                    <BizTimeList />
                    <VehicleList />
                    <NoticeList />
                    <Button onKakao={kakaoChannel} />
                </FlickPanel>
            </Element>
        </Section>
    );
}